import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

// Angular Material Modules
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';

// Type definition for the card's statistics
export type ImageCardStates = {
  views?: string | number;
  comments?: string | number;
  likes?: string | number;
};

@Component({
  selector: 'lib-image-card',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule
  ],
  templateUrl: './image-card.component.html',
})
export class ImageCardComponent {
  /** The source URL for the card's image. Required. */
  @Input({ required: true }) image!: string;

  /** The main title for the card. Required. */
  @Input({ required: true }) title!: string;

  /** The secondary text or subtitle. Required. */
  @Input({ required: true }) secondaryText!: string;

  /** An object containing view, comment, and like counts. Optional. */
  @Input() states: ImageCardStates = {};

  /** The alt text for the image. Defaults to the title. Optional. */
  @Input() alt?: string;

  /** Emits when the card is clicked, mimicking CardActionArea. */
  @Output() cardClick = new EventEmitter<void>();

  onCardClick(): void {
    this.cardClick.emit();
  }

  get altText(): string {
    return this.alt || this.title;
  }
}